import fileSaver from '../../../../../helpers/download.helper'
import { AxiosService } from './../../../../../services/axios.service'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { clientsReportConstants } from './clients-report.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const exportData = params => dispatch => {
	dispatch({
		type: clientsReportConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get(`${AdminReportsService.baseURL}/exportar-clientes`, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = downloadData => async dispatch => {
	dispatch({
		type: clientsReportConstants.DOWNLOAD_DATA
	})

	await fileSaver(downloadData, 'exportacao-de-clientes.csv')
}

export const clientsReportActions = { exportData }
